import { useLocation, useNavigate } from "react-router-dom";

export default function AdminNavbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: "Home", path: "/admin" },
    { label: "Users", path: "/admin/users" },
    { label: "Products", path: "/admin/products" },
    { label: "Orders", path: "/admin/orders" },
    { label: "Profile", path: "/admin/profile" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="wf-nav">
      <button
        type="button"
        className="wf-brand-inline"
        onClick={() => navigate("/")}
      >
        <img
          src="/favicon-48-white.png"
          alt="Balitah logo"
          className="wf-brand-logo"
        />
        BALITAH
        <span>Admin</span>
      </button>

      <div />

      <div className="wf-nav-actions">
        {navItems.map((item) => (
          <button
            key={item.path}
            className={`wf-btn${isActive(item.path) ? " wf-btn--active" : ""}`}
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
